import { StringPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../constants';

export default (): StringPointerParameterValue => ({
  type: PARAMETER_VALUE_TYPE.STRING_POINTER,
  variable: null,
});
